import { ref } from 'vue'

export default () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = ref(Object.fromEntries(urlSearchParams.entries()))
  const addSearchParam = (name, value) => {
    if (!value) {
      urlSearchParams.delete(name)
    } else {
      urlSearchParams.set(name, value)
    }

    window.history.pushState(
      {},urlSearchParams.toString(),`?${urlSearchParams.toString()}`
    )

    params.value = Object.fromEntries(urlSearchParams.entries())
  }

  return { params, addSearchParam }
}